import Grid from "@material-ui/core/Grid";
import range from "lodash/range";
import React, { useEffect } from "react";
import RadioScale from "src/shared/components/RadioScale";
import { TemplateType, TemplateTypeUtil } from "src/api/types";
import { noneIdValue } from "../../TemplateEditorPage";
import { useStyles } from "./styles";
import { ITemplateSettingsProps } from "./types";
import { Box } from "@material-ui/core";

export const TemplateSettings = ({
  SaveButtonWithProps,
  name,
  templates,
  // parentId,
  templateId,
  copyId,
  defaultPositiveText,
  defaultNegativeText,
  defaultReversed,
  defaultScale,
  enableParentQuestions,
  scalePreview,
  templateType,
  parentTemplate,
  // handleParentTemplateChange,
  handleTemplateTypeChange,
  handleCopyTemplateChange,
  handleEnableParentQuestions,
  handleReversedChange,
  handleScaleChange,
  loadCopyQuestions,
  handleNameChange,
  handleDefaultPositiveTextChange,
  handleDefaultNegativeTextChange,
  handleScalePreviewChange,
}: ITemplateSettingsProps) => {
  const classes = useStyles();


  useEffect(() => {
    document.body.classList.add("admin-templage-setting");
    return () => {
      document.body.classList.remove("admin-templage-setting");
    };
  }, []);

  return (
    <Box>
      <SaveButtonWithProps />
      <Box>
        Name:{" "}
        <input
          placeholder="Template Name"
          value={name}
          onChange={handleNameChange}
        />
      </Box>
      <Box>
        <p>
          <input
            type="checkbox"
            checked={enableParentQuestions}
            onChange={handleEnableParentQuestions}
          />{" "}
          Enable parent surveys on this template?
        </p>
      </Box>
      {parentTemplate && (
        <span className={classes.warning}>
          Template is a parent. If you want to make it inherit you must remove
          all children first.
        </span>
      )}
      {(templates.length !== 0 || !parentTemplate) && (
        <Box>
          {/* TODO: completely remove inherit feature (API logic included) :: Confirm first with Kevin before removing */}
          {/* Inherit:
          <select
            onChange={(e) => {
              console.log("this is running");
              handleParentTemplateChange(e);
            }}
            value={parentId === null ? noneIdValue : parentId}
          >
            <option key="none" value={noneIdValue} />
            {templates
              .filter(
                (template) =>
                  template.parentId === null && templateId !== template.id
              )
              .map((template) => (
                <option key={template.id} value={template.id}>
                  {template.name}
                </option>
              ))}
          </select> */}
          Copy:
          <select
            onChange={handleCopyTemplateChange}
            value={copyId === null ? noneIdValue : copyId}
          >
            <option key="none" value={noneIdValue} />
            {templates
              .filter(
                (template) =>
                  template.parentId === null && templateId !== template.id
              )
              .map((template) => (
                <option key={template.id} value={template.id}>
                  {template.name}
                </option>
              ))}
          </select>
          <button onClick={loadCopyQuestions}>Copy</button>
        </Box>
      )}
      <Box>
        <select onChange={handleTemplateTypeChange} value={templateType}>
          {[
            TemplateType.gritLeadership,
            TemplateType.noGridNoCoach,
            TemplateType.noGrid,
          ].map((s: TemplateType) => (
            <option key={s} value={s}>
              {TemplateTypeUtil.templateTypeToString(s)}
            </option>
          ))}
        </select>
      </Box>
      <Box className={classes.defaultScaleProperties}>
        <Box>
          Default Scale Properties: <br />
          Scale:{" "}
          <select onChange={handleScaleChange} value={defaultScale.toString()}>
            {range(1, 11).map((i) => (
              <option key={i} value={i}>
                {i}
              </option>
            ))}
          </select>
        </Box>
        <Box>
          Reversed:{" "}
          <input
            checked={defaultReversed}
            onChange={handleReversedChange}
            type="checkbox"
          />
        </Box>
        Positive Text:{" "}
        <textarea
          rows={2}
          value={defaultPositiveText}
          onChange={handleDefaultPositiveTextChange}
        />
        Negative Text:{" "}
        <textarea
          rows={2}
          value={defaultNegativeText}
          onChange={handleDefaultNegativeTextChange}
        />{" "}
   
        <Grid container={true} direction="row" alignItems="center">
          <span>Preview: </span>
          <Box className={classes.radioPreview}>
            <RadioScale
              scale={defaultScale}
              onChange={handleScalePreviewChange}
              reversed={defaultReversed}
              value={scalePreview}
              positiveText={defaultPositiveText}
              negativeText={defaultNegativeText}
            />
          </Box>
        </Grid>
      </Box>
    </Box>
  );
};



// WEBPACK FOOTER //
// ./src/features/admin/pages/template-editor/components/template-settings/TemplateSettings.tsx